<template>
  <div class="home">
    <main>
      <Hero />
      <Overview /> 
      <Accomplishments />
      <Appointments />
    </main>
    <Footer />
  </div>
</template>

<script>
import Hero from '../components/Hero.vue'
import Overview from './Overview.vue'
import Accomplishments from './Accomplishments.vue'
import Appointments from './Appointments.vue'
import Footer from '../components/Footer.vue'

export default {
  name: 'Home',
  props: {},
  components: {
    Hero,
    Overview,
    Accomplishments,
    Appointments,
    Footer
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:900&display=swap');
</style>
